import './index.scss';
import manager from '../../../Manager';
function ModalStorageFull(){

    const handleAddExtraQuota = () => {
        let extraQuoraUrl = manager.settings.businessAccountManageUrl.replace("/business/dashboard", "/business/setting/extraQuota");
        window.open(extraQuoraUrl, '_blank');
    }

    return (
        <div className="tbcourse-modal tbcourse-modal-storage-full modal" id="tbcourse-modal-storage-full" tabIndex="-1" role="dialog" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content rounded-12">
                    <div className="modal-header border-0">
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body font-size-14 font-family-inter">
                        <h1 className="font-weight-700 font-size-28">Your Storage is Full</h1>
                        <p>You have reached the storage capacity limit for your account. To upload new video you can add extra quota for your account.</p>
                        <br/>
                        <br/>
                        <br/>
                        <br/>
                        <div className="d-grid gap-2">
                            <button type="button" className="btn btn-primary rounded-6 font-size-12 font-weight-700 py-2" onClick={handleAddExtraQuota}>Add Extra Quota</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ModalStorageFull;
